import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type CustomAxiosRequestConfig } from '~/domains/platform/infra/http/http-client-factory'

export const blobClient = (config: CustomAxiosRequestConfig, client = httpClientBanking) =>
  client<Blob>({
    ...config,
    method: config.method ?? 'POST',
    responseType: 'blob'
  })
